// extracted by mini-css-extract-plugin
export default {"products":"It-z","card":"Jt-z","oosMessaging":"Kt-z"};